// EP-73 — deep-link target per catalog feature for the coach CTA. Mirrors
// the server FeatureCatalog `route`; `:id` routes resolve to the list page
// (the coach points at the capability, the user picks the record). Pure map
// so it's trivially unit-tested.
export const FEATURE_ROUTES: Record<string, string> = {
  property_created: '/properties/new',
  unit_created: '/properties',
  customer_created: '/customers/new',
  lease_created: '/leases/new',
  esign_link_sent: '/leases',
  lease_signed: '/leases',
  meter_added: '/meters',
  meter_reading_recorded: '/meters',
  caf_configured: '/properties',
  invoice_created: '/invoices/generate',
  invoice_sent: '/invoices',
  payment_recorded: '/payments/record',
  report_viewed: '/reports',
  report_exported: '/reports',
  maintenance_created: '/maintenances',
  maintenance_resolved: '/maintenances',
  equipment_created: '/cmms/equipment',
  work_order_created: '/cmms/work-orders',
  vehicle_added: '/parking',
  parcel_scanned: '/parcels',
  parcel_assigned: '/parcels',
  timesheet_logged: '/timesheets',
  expense_created: '/expenses',
  bank_statement_uploaded: '/bank-reconciliation',
  gl_account_setup: '/accounting',
  late_fee_policy_set: '/properties',
  etax_issued: '/invoices',
  liff_published: '/settings',
  rich_menu_set: '/settings',
  microsite_published: '/properties',
  announcement_published: '/announcements',
  line_oa_configured: '/settings',
  template_customized: '/settings/templates',
}
